import * as React from "react";
import {
  TrackerPolicy,
  TrackerPolicyContentStatusOptions,
  TrackerPolicyContentTypeOptions
} from "@models/tracker-policy";
import {Modal, Table, Button, Divider, Avatar, Tooltip} from "antd";
import {FormattedMessage, injectIntl, intlShape} from "react-intl";
import FormattedDateTime from "@components/custom/FormattedDateTime";
import {PaginationDefaultParams} from "../../custom/Paginator";
import {NavLink} from "react-router-dom";
import {Icon} from 'antd';
import {getFormattedPrice} from "../../../utils/index";
import __i18n from "../../../intl/__i18n";

type Props = {
  data: TrackerPolicy[];
  loading: boolean;
  deleteFn: (item: TrackerPolicy) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const TrackerPoliciesTable: React.FC<Props> = props => {
  const {data, loading, currentPage, deleteFn, intl} = props;
  const {formatMessage} = intl;
  const pageOffset = (currentPage - 1) * PaginationDefaultParams.count;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (a, b, i) => <span>{i + 1 + pageOffset}</span>
    },
    {
      title: "",
      width: 30,
      align:"right",
      dataIndex: "avatar_url",
      key: "avatar_url",
      render: (a, record) => (
        <Avatar
          size="small"
          src={record.avatar_url ? record.avatar_url : null}
          icon="user"
        />
      )
    },
    {
      title: __i18n("Mobile Number"),
      dataIndex: "msisdn",
      key: "msisdn",
      width: 100,
      align: "right",
    },
    {
      title: __i18n("Name"),
      dataIndex: "full_name",
      align: "right",
      render: (a, record) => `${record.name || ""} ${record.family || ""}`.trim()
    },
    {
      title: __i18n("Balance"),
      dataIndex: "balance",
      key: "balance",
      align:"center",
      render: (balance, record) => getFormattedPrice(balance)
    },
    {
      title: __i18n("Carrier"),
      dataIndex: "carrier",
      key: "carrier",
      align: "center",
      render: (carrier, record) => carrier
    },
    {
      title: __i18n("Join date"),
      dataIndex: "created_at",
      key: "created_at",
      align: "created_at",
      render: (created_at, record) => <FormattedDateTime date={created_at}/>
    },
    {
      title: "",
      align: "left",
      render: (text, record) => (
        <NavLink to={`/public-users/${record.id}/report`}>
          <Button type="link" size={`small`}>
            <Icon type="info-circle" />
          </Button>
        </NavLink>
      )
    }
  ];
  
  return (
    <Table
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default injectIntl(TrackerPoliciesTable);
